import { render, staticRenderFns } from "./ESGScopeConversionTable.vue?vue&type=template&id=cf7b5e42"
import script from "./ESGScopeConversionTable.vue?vue&type=script&lang=js"
export * from "./ESGScopeConversionTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports